import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Avatar, Button, Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import { alpha } from "@mui/material/styles"
import PropTypes from "prop-types"
import React, { useMemo } from "react"
import { stringToColor } from "./utils"

const UserAvatar = React.memo(({ currentUser, onClick, isMenuOpen }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))

  const initials = useMemo(() => {
    const firstName = currentUser?.first_name[0]
    const lastName = currentUser?.last_name[0]
    return `${firstName || ""}${lastName || ""}`.toUpperCase()
  }, [currentUser?.first_name, currentUser?.last_name])

  const shortName = useMemo(() => {
    const firstName = currentUser?.first_name.split(" ")[0]
    const lastName = currentUser?.last_name.split(" ")[0]
    return `${firstName || ""} ${lastName || ""}`.trim()
  }, [currentUser?.first_name, currentUser?.last_name])

  return (
    <Button
      onClick={onClick}
      sx={{
        py: 0,
        px: 0.5,
        textTransform: "none",
        color: "text.primary",
        minWidth: "auto",
        "&:hover": {
          bgcolor: alpha(theme.palette.primary.main, 0.04),
        },
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ "&:hover": { color: "primary.main" } }}>
        <Avatar
          sx={{
            width: { xs: 24, sm: 28, md: 32 },
            height: { xs: 24, sm: 28, md: 32 },
            bgcolor: stringToColor(currentUser?.name || ""),
            fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" },
          }}
        >
          {initials}
        </Avatar>
        {!isMobile && (
          <Typography
            variant="body1"
            sx={{
              ml: 1,
              display: { xs: "none", sm: "block" },
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            {shortName}
          </Typography>
        )}
        {isMenuOpen ? <ExpandLess sx={{ fontSize: 20 }} /> : <ExpandMore sx={{ fontSize: 20 }} />}
      </Stack>
    </Button>
  )
})

UserAvatar.propTypes = {
  currentUser: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  isMenuOpen: PropTypes.bool.isRequired,
}

UserAvatar.displayName = "UserAvatar"

export default UserAvatar
